import BambuserPlayerComponent from './bamPlayer';

export default class BambuserInlinePlayerComponent extends BambuserPlayerComponent {

  constructor() {
    super();
    this._inlinePlayer = true;
  }

  getAttribute(name) {
    if (name === 'standalone') return 'true';
    if (name === 'player-fit') return 'fill-parent';
    if (name === 'show-poster-when-paused') return 'false';
    if (name === 'poster') return '';
    if (name === 'event-id') return this.getAttribute('show-id');
    return super.getAttribute(name);
  }

  _getOverridableConfig() {
    const { autoplay: configAutoplay } = this._getPlayerIntegrationConfig();
    const { autoplay = false } = this._attr;
    const shouldAutoplay = (!autoplay || ['none', 'false'].includes(autoplay)) ? configAutoplay : true;

    return {
      autoplay: shouldAutoplay,
      withBaaSPlayerPreloading: false,
      deferReactAppInit: false,
      disableTouchMoveScrollPrevention: true,
      hideCloseButton: true,
    };
  }

  _onIframeLoaded() {
    if (!this.embedInstance) return;
    this.embedInstance._shouldClosePlayerOnLastBackNavigation = false;
    this.embedInstance?.loadPlayer();

    // REMARK: As this inline player does not use BaaS player preloading
    // we'll never receive the callback that resolves the player ready promise,
    // so for good measures we resolve it here to avoid any potential deadlocks
    // waiting for the player to be ready. If more players happened to be queued
    // up after this one.
    // In a perfect world we'd want to resolve this somewhere appriopriately in the
    // react app once the player is actually ready if the player was started without
    // the preloading option.
    this._playerReady.resolve();
  }

  _updateStylesheet() {
    this.wrapper.classList.add('player-ui-loaded');
    this.wrapper.classList.add('is-playing');
    this.wrapper.classList.add('played-at-least-once');
    super._updateStylesheet();
  }

  set _videoWidth(value) {
    this.__videoWidth = value;
  }

  get _videoWidth() {
    return this.__videoWidth || this.offsetWidth || 1;
  }

  set _videoHeight(value) {
    this.__videoHeight = value;
  }

  get _videoHeight() {
    return this.__videoHeight || this.offsetHeight || 1;
  }

}
